/**
 * CoConnect — canonical API base URL configuration.
 *
 * The Express application mounts public API routers under `/api`. Deployments
 * sometimes provide VITE_API_URL as only an origin (for example
 * `http://localhost:5000`) and older code assumed callers always included the
 * `/api` suffix. Normalize the value once so every client path uses the same
 * contract and authentication cannot silently drift to `/auth/*`.
 */
export const normalizeApiBaseUrl = (raw?: string | null): string => {
  const supplied = String(raw ?? '').trim();
  if (!supplied) return '/api';

  const withoutTrailingSlash = supplied.replace(/\/+$/, '');
  if (!withoutTrailingSlash || withoutTrailingSlash === '/') return '/api';
  if (/\/api$/i.test(withoutTrailingSlash)) return withoutTrailingSlash;

  return `${withoutTrailingSlash}/api`;
};

export const API_BASE_URL = normalizeApiBaseUrl((import.meta as any).env?.VITE_API_URL);

export const API_URLS = {
  BASE: API_BASE_URL,
  AUTH: {
    login: `${API_BASE_URL}/auth/login`,
    me: `${API_BASE_URL}/auth/me`,
    logout: `${API_BASE_URL}/auth/logout`,
  },
};
